export default "<tc-generic-list #proposalsList id=\"dashboard-proposals-list\"></tc-generic-list>";